var _style, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgHandRaised = _ref => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: 0,
    y: 0,
    viewBox: "0 0 1.025 0.782",
    xmlSpace: "preserve",
    width: 20,
    height: 20,
    xmlns: "http://www.w3.org/2000/svg",
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style869"
  }, ".st0{fill:#ffd3b6}")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M220.8 196.584",
    id: "path871"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g1059",
    transform: "matrix(.05125 0 0 .05125 -14.217 -12.843)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M288.372 256.007",
    id: "path1044",
    style: {
      strokeWidth: 0.0389037
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.69 257.645c-.424-.378-1.361-.899-3.287.953-.358.342-.572.467-.844.762v-9.134c0-.591-.467-1.074-1.062-1.074-.596 0-1.078.483-1.078 1.074v5.419c0 .506-.654.549-.767.132v-6.465c0-.592-.466-1.074-1.062-1.074-.595 0-1.077.478-1.077 1.074v6.485c-.082.397-.665.381-.708-.047v-5.664a1.06 1.06 0 0 0-1.062-1.07c-.596 0-1.078.478-1.078 1.07v5.575c-.004.007-.004.02-.004.039 0 .486-.626.529-.74.136v-3.992a1.06 1.06 0 0 0-1.061-1.07c-.595 0-1.078.479-1.078 1.07v9.392a4.768 4.768 0 0 0 2.739 4.314v1.525c0 .591.482 1.074 1.074 1.074h4.295c.591 0 1.073-.483 1.073-1.074v-1.081a2.517 2.517 0 0 0 1.755-1.031.313.313 0 0 0 .031-.047c.035-.039.078-.109.128-.21.028-.047.051-.093.074-.144.494-1 1.623-3.708 3.646-5.458.416-.417.517-1.082.093-1.46z",
    id: "path1046",
    style: {
      strokeWidth: 0.0389037,
      fill: "#ffd469"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M288.726 266.013H285.4l.007-.007h-.871a4.774 4.774 0 0 1-2.027-.451v1.361c.194.102.38.168.54.168h5.373c.156 0 .339-.051.53-.133v-.949l-.226.012z",
    id: "path1048",
    style: {
      strokeWidth: 0.0389037,
      fill: "#ffb636"
    }
  })));
};
export { SvgHandRaised as ReactComponent };